import { authHeader, httpHelper } from '../helpers';
import { post, get } from 'axios';

export const opbMngService = {
    findOpbInfoList,
    addOpbInfo,
    modOpbInfo,
    getOpbInfo,
    modulesList,
    getPrjNOXls
};

function findOpbInfoList(formData){
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/opbmng/list`, formData, headers);
}

function addOpbInfo(formData){
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/opbmng/addOpbInfo`, formData, headers);
}

function modOpbInfo(formData){
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/opbmng/modOpbInfo`, formData, headers);
}

function getOpbInfo(formData){
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/opbmng/info`, formData, headers);
}

function modulesList(opbID){
    const headers = {headers: authHeader()};
    return get(httpHelper.getApiUrl()+`/opbmng/modulesList/${opbID}`, headers);
}

function getPrjNOXls(formData) {
    const headers = {headers: authHeader(), responseType: 'blob'};
    return post(httpHelper.getApiUrl()+`/opbmng/getPrjNoXls`, formData, headers);
}